export default __webpack_public_path__ + "static/media/discoverImage.3b9db421.png";